const state = {
  list: [],
  pagination: [],
  formSend: false,
  reloadList: false,
  options: {},
  searchReferableUsers: [],
};

export default state;
